import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';

import { useBasicQuestInfo } from '@zealy/queries';

import { PartnershipQuest } from '#components/Tasks/components/PartnershipQuest';
import { useDebouncedValue } from '#hooks/useDebouncedValue';

import { useError } from '../../../../FormError.context';

export const PartnershipQuestPreview = ({ index }: { index: number }) => {
  const task = useWatch({
    name: `tasks.${index}`,
  });

  const debouncedValue = useDebouncedValue(task?.settings?.questUrl as string, 500);

  const { setError, clearError } = useError(`tasks.${index}.settings.questUrl`);
  const questId = debouncedValue?.split('?')[0]?.split('/').pop();

  const { isLoading, data, status, isFetching, isFetched } = useBasicQuestInfo(questId || '_');

  useEffect(() => {
    if (status === 'success') {
      clearError();
    } else if (status === 'error') {
      setError('Quest not found');
    }

    return clearError;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, data, isLoading, isFetching, isFetched]);

  return <PartnershipQuest task={task} preview={true} index={index} />;
};
